import Skeleton from './Skeleton'

/**
 * Exact-layout placeholder for `CartItemCard` / `RecentlyBrowsedItemCard`
 * (RP-5936 prototype geometry): the 130×156 image tile fixes the row height,
 * so the swap to content causes no layout shift.
 */
export default function ItemCardSkeleton() {
  return (
    <div
      className="flex min-w-[340px] w-full items-center gap-16 bg-surface"
      data-testid="item-card-skeleton"
    >
      <Skeleton w={130} h={156} className="shrink-0" />
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-10 self-stretch">
        <Skeleton h={16} className="w-[60%]" />
        <Skeleton h={12} className="w-[38%]" />
        <Skeleton h={12} className="w-[26%]" />
      </div>
    </div>
  )
}
